// Tema Claro (atual)
export const lightTheme = {
  name: 'light',
  colors: {
    // Cores principais do projeto atual
    background: '#FFFFFF',
    foreground: '#4E4B59',
    
    // Cores de texto
    text: '#4E4B59',
    textSecondary: '#9997A0',
    textMuted: '#9997A0',
    
    // Cores de marca
    red: '#F14F5C',
    purple: '#7683F6',
    blue: '#2D4677',
    blueDark: '#1A2C50',
    purpleDark: '#6741A3',
    
    // Cores de elementos
    card: '#FFFFFF',
    cardBackground: 'hsl(220, 14%, 97%)',
    cardBorder: 'hsl(220, 13%, 85%)',
    
    // Cores de bordas e inputs
    border: '#D3D2D7',
    input: '#D3D2D7',
    
    // Cores de sucesso
    success: '#44E47A',
    successHover: '#3dcf6e',
    
    // Cores de fundo
    dropzone: '#EAEAEA',
    
    // Breadcrumb
    breadcrumbBorder: '#D3D2D7',
    breadcrumbText: '#9997A0',
    breadcrumbIcon: '#000000',
    
    // Plan badge
    planBorder: '#085C6E',
    planText: '#085C6E',
  },
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.08)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
  }
}

// Tema Escuro (baseado no projeto de referência)
export const darkTheme = {
  name: 'dark',
  colors: {
    // Cores principais do tema escuro
    background: 'hsl(215, 35%, 12%)',
    foreground: 'hsl(210, 20%, 95%)',
    
    // Cores de texto
    text: 'hsl(210, 20%, 95%)',
    textSecondary: 'hsl(215, 15%, 65%)',
    textMuted: 'hsl(215, 15%, 65%)',
    
    // Cores de marca (ajustadas para tema escuro)
    red: '#F14F5C',
    purple: '#7683F6',
    blue: 'hsl(210, 80%, 55%)',
    blueDark: 'hsl(210, 80%, 55%)',
    purpleDark: '#7683F6',
    
    // Cores de elementos
    card: 'hsl(215, 30%, 16%)',
    cardBackground: 'hsl(215, 30%, 16%)',
    cardBorder: 'hsl(215, 25%, 22%)',
    
    // Cores de bordas e inputs
    border: 'hsl(215, 25%, 22%)',
    input: 'hsl(215, 25%, 22%)',
    
    // Cores de sucesso
    success: '#44E47A',
    successHover: '#3dcf6e',
    
    // Cores de fundo
    dropzone: 'hsl(215, 25%, 20%)',
    
    // Breadcrumb
    breadcrumbBorder: 'hsl(215, 25%, 22%)',
    breadcrumbText: 'hsl(215, 15%, 65%)',
    breadcrumbIcon: 'hsl(210, 20%, 95%)',
    
    // Plan badge
    planBorder: 'hsl(210, 80%, 55%)',
    planText: 'hsl(210, 80%, 55%)',
  },
  shadows: {
    sm: '0 1px 2px 0 hsl(210 80% 55% / 0.05)',
    md: '0 4px 6px -1px hsl(210 80% 55% / 0.08)',
    lg: '0 10px 15px -3px hsl(210 80% 55% / 0.1)',
  }
}

export const getTheme = (themeName) => {
  return themeName === 'dark' ? darkTheme : lightTheme
}
